import type { ReactNode } from "react";

type ActiveFilterFieldProps = {
  label: string;
  icon: ReactNode;
};

export const ActiveFilterField = ({ label, icon }: ActiveFilterFieldProps) => {
  return (
    <div className="flex gap-1 shrink-0 rounded-l-lg border-l border-t border-b border-border-dark-min bg-bg-dark-min px-1 py-0.5 h-6 items-center">
      {icon}
      <span className="text-xs leading-4 font-normal text-text-dark-max">
        {label}
      </span>
    </div>
  );
};
